import { Provider } from '@angular/core';

import { LoadingPanelService } from './lib';

export * from './lib/components';
export * from './lib/services';

export function provideLoading(): Provider[] {
  return [LoadingPanelService];
}
